import { createFileRoute } from "@tanstack/react-router";

import { AdjustmentFormPage } from "../../../../features/inventory/adjustment-form-page";
import { adjustmentFormSearch } from "../../../../features/inventory/inventory-search";

export const Route = createFileRoute("/_app/inventory/adjustments/new")({
  validateSearch: adjustmentFormSearch,
  component: AdjustmentFormRoute,
});

function AdjustmentFormRoute() {
  const search = Route.useSearch();
  // A new form per mode and starting point (its Idempotency-Key and lines start over).
  return <AdjustmentFormPage key={`${search.mode}-${search.variantId ?? ""}`} search={search} />;
}
